import SvgIcon from "../svg-icon/SvgIcon";
import React from 'react';

export const Preview = (props) => {
  return (
    <SvgIcon {...props} width="22" height="22" viewBox="0 0 22 22">
      <g id="Grupo_4079" data-name="Grupo 4079" transform="translate(1.011 2.016)">
        <path d="M-5326.416,4904.069h-5.629a1.829,1.829,0,0,0-1.25.6,3.05,3.05,0,0,0-.328,1.609v10.275a4.908,4.908,0,0,0,.453,2.552,2.4,2.4,0,0,0,1.891.765h9.959a3.779,3.779,0,0,0,2.172-.475,2.541,2.541,0,0,0,.65-1.834v-5.789"
              transform="translate(5333.636 -4901.117)" fill="none" stroke="currentColor" strokeLinecap="round"
              strokeWidth="2"/>
        <path d="M-.006,3.559,3.559-.006m0,0L7.1,3.536M3.559-.006l-.05,15.99"
              transform="translate(12.787 -0.008) rotate(45)" fill="none" stroke="currentColor" strokeLinecap="round"
              strokeLinejoin="round" strokeWidth="2"/>
      </g>
    </SvgIcon>
  );
};

Preview.propTypes = {}

Preview.defaultProps = {}

export default Preview;